import { call, put, takeLatest } from "redux-saga/effects";
import {
  onGetUsers,
  onGetUsersSuccess,
  onGetUsersError,
  onPostUsers,
  onPostUsersSuccess,
  onPostUsersError,

} from "../Store/Slices/userSlice";
import { callGetUsersApi, callPostUsersApi } from "../Context/adminApi";

function* getUsersSaga({ payload }) {
  try {
    const response = yield call(callGetUsersApi, payload ?? {});
    const code = response?.httpStatusCode ?? response?.status;
    if (code === "200" || code === 200) {
      const data = response?.data ?? response;
      yield put(
        onGetUsersSuccess({
          data: Array.isArray(data) ? data : (data?.users ?? data?.data ?? []),
          message: response?.message ?? "",
        }),
      );
    } else {
      yield put(
        onGetUsersError({
          message: response?.message ?? "Failed to load users",
        }),
      );
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ??
      error?.message ??
      "Failed to load users";
    yield put(onGetUsersError({ message }));
  }
}
function* postUsersSaga({ payload }) {

  try {
    const response = yield call(callPostUsersApi, payload ?? {});

    const code = response?.httpStatusCode ?? response?.status ?? response?.data?.status;
    const isSuccess = code === "200" || code === 200 || code === "201" || code === 201;
    const responseData = response?.data ?? response;
    if (isSuccess) {
      yield put(
        onPostUsersSuccess({
          data: responseData?.data ?? responseData,
          message: response?.message ?? responseData?.message ?? "User created successfully",
          status_code: String(code ?? 201),
        }),
      );
    } else {
 
      yield put(
        onPostUsersError({
          message: response?.message ?? "Failed to create user",
          status_code: code ?? 400,
        }),
      );
    }
  } catch (error) {
    ;
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(
      onPostUsersError({
        message,
        status_code: 400 ?? error.response?.status ?? error.status,
      }),
    );
  }
}

export default function* userSaga() {
  yield takeLatest(onGetUsers.type, getUsersSaga);
  yield takeLatest(onPostUsers.type, postUsersSaga);
}
